import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';

import {CoreModule} from '@Common/core/core.module';

import {CommonModuleP8} from '@Common/common-p8.module';
import {AppRoutingModule} from './app-routing';

import {HandlerError} from '@Common/handler-error';
import {FlexLayoutModule} from '@Common/widgets/flex-layout/flex-layout.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonModule, registerLocaleData} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAngularModule} from '@Common/mat-angular.module';
import { MatTreeModule } from '@angular/material/tree';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {AppComponent} from './app.component';
import {AdminModule} from './admin/admin.module';
import {AuthGuardService} from '@Services/auth';
import {AuthenticatedGuardService} from './common/guards/authenticated-guard.service';
import {SuperviseurGuardService} from './common/guards/superviseur-guard.service';
import {GestionModule} from './gestion/gestion.module';
import {AccueilComponent} from './accueil/accueil.component';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {CustomPaginatorService} from './common/custom-paginator/custom-paginator.service';
import {AdminGuardService} from './common/guards/admin-guard.service';
import {CheckGuardService} from '../common/core/services/guards/check-guard.service';
import {CommonDematModule} from "app/demat/common/common.module";

registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

@NgModule({
  declarations: [
    AppComponent,
    AccueilComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CoreModule,
    CommonModuleP8,
    AppRoutingModule,
    FlexLayoutModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAngularModule,
    MatTreeModule,
    MatInputModule,
    MatFormFieldModule,
    AdminModule,
    GestionModule,
    CommonDematModule,
  ],

  providers: [
    AuthGuardService,
    AuthenticatedGuardService,
    SuperviseurGuardService,
    AdminGuardService,
    CheckGuardService,
    {provide: LOCALE_ID, useValue: 'fr-FR'},
    {provide: ErrorHandler, useClass: HandlerError},
    {provide: MatPaginatorIntl , useClass: CustomPaginatorService},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
